@use '../../../scss/utility/functions' as utility;
@use 'button-group-item-vars';
@use 'button-group-item-common';

:host([direction='horizontal']:not(:first-child)) .wb-button {
  @include button-group-item-common.wb-button-group-item-horizontal-not-first;
}

:host([direction='vertical']:not(:first-child)) .wb-button {
  @include button-group-item-common.wb-button-group-item-vertical-not-first;
}

:host([direction='horizontal']:not(:last-child)) .wb-button::part(button) {
  @include button-group-item-vars.wb-button-group-item-horizontal-not-last-vars;
}

:host([direction='horizontal']:not(:first-child)) .wb-button::part(button) {
  @include button-group-item-vars.wb-button-group-item-horizontal-not-first-vars;
}

:host([direction='vertical']:not(:last-child)) .wb-button::part(button) {
  @include button-group-item-vars.wb-button-group-item-vertical-not-last-vars;
}

:host([direction='vertical']:not(:first-child)) .wb-button::part(button) {
  @include button-group-item-vars.wb-button-group-item-vertical-not-first-vars;
}

:host([variant='primary']) .wb-button::part(button) {
  @include button-group-item-vars.wb-button-group-item-primary-button-vars;
}

:host([variant='primary'][selected]:not([disabled])) .wb-button::part(button) {
  &,
  &:focus,
  &:hover,
  &:active {
    @include button-group-item-vars.wb-button-group-item-primary-selected-vars;
    @include button-group-item-common.wb-button-group-item-selected;
  }
  &:focus,
  &:focus-within {
    @include button-group-item-vars.wb-button-group-item-primary-selected-focus-vars;
  }
}

:host([variant='secondary'][selected]:not([disabled])) .wb-button::part(button) {
  &,
  &:focus,
  &:hover,
  &:active {
    @include button-group-item-vars.wb-button-group-item-secondary-selected-vars;
    @include button-group-item-common.wb-button-group-item-selected;
  }
  &:focus,
  &:focus-within {
    @include button-group-item-vars.wb-button-group-item-secondary-selected-focus-vars;
  }
}

:host([variant='translucent'][selected]:not([disabled])) .wb-button::part(button) {
  &,
  &:focus,
  &:hover,
  &:active {
    @include button-group-item-vars.wb-button-group-item-translucent-selected-vars;
    @include button-group-item-common.wb-button-group-item-selected;
  }
  &:focus,
  &:focus-within {
    @include button-group-item-vars.wb-button-group-item-translucent-selected-focus-vars;
  }
}

.wb-button {
  @include button-group-item-common.wb-button-group-item-button;
}

.wb-button[icon-only] {
  @include button-group-item-common.wb-button-group-item-icon-only;
}

.wb-button::part(button):focus,
.wb-button::part(button):focus-within {
  @include button-group-item-common.wb-button-group-item-focus;
}
